import { Description, AllInbox, AccountBox, DirectionsBoat, People, PieChart, ViewModule, IntegrationInstructions } from '@mui/icons-material';

export const menuObject = [
    {
        "menuLabel": "Dashboard",
        "menuDisplay": "Dashboard",
        "menuIcon": <PieChart />,
        "tableName": "DashBoard",
        "menuUrl": "dashboard"
    },
    
    {
        "menuLabel": "Sales",
        "menuIcon": <Description />,
        "menuOpen": false,
        "tableName": "",
        "menuUrl": "",
        "subMenus": [
            {
                "subMenuLabel": "Invoices",
                "subMenuDisplay": "Invoices",
                "subMenuOpen": false,
                "tableName": "Invoice",
                "subMenuUrl": "go/invoiceList",
                "subSubMenus": []
            },
			{
                "subMenuLabel": "Entities",
                "subMenuDisplay": "Entities",
                "subMenuOpen": false,
                "tableName": "Account",
                "subMenuUrl": "go/entities",
                "subSubMenus": []
            },
			            {
                "subMenuLabel": "Quotes",
                "subMenuDisplay": "Quotes",
                "subMenuOpen": false,
                "tableName": "Quote",
                "subMenuUrl": "go/quoteList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "ApproveQuotes",
                "subMenuDisplay": "ApproveQuotes",
                "subMenuOpen": false,
                "tableName": "Quote",
                "subMenuUrl": "go/approveQuoteList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Quote Requests",
                "subMenuDisplay": "Quote Requests",
                "subMenuOpen": false,
                "tableName": "QuoteRequest",
                "subMenuUrl": "go/quoteList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "ServiceTypes",
                "subMenuDisplay": "ServiceTypes",
                "subMenuOpen": false,
                "tableName": "Quote",
                "subMenuUrl": "go/serviceTypeList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "ChargeRules",
                "subMenuDisplay": "ChargeRules",
                "subMenuOpen": false,
                "tableName": "ChargeRule",
                "subMenuUrl": "go/chargeRules",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "TransportClauses",
                "subMenuDisplay": "Transport Clauses",
                "subMenuOpen": false,
                "tableName": "TransportClause",
                "subMenuUrl": "go/transportClauses",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Locations",
                "subMenuDisplay": "Locations",
                "subMenuOpen": false,
                "tableName": "location",
                "subMenuUrl": "go/locationList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Commodities",
                "subMenuDisplay": "Commodities",
                "subMenuOpen": false,
                "tableName": "Commodity",
                "subMenuUrl": "go/commodityList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "DangerousGoods",
                "subMenuDisplay": "DangerousGoods",
                "subMenuOpen": false,
                "tableName": "dangerous goods",
                "subMenuUrl": "go/dangerousGoodsList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Currencies",
                "subMenuDisplay": "Currencies",
                "subMenuOpen": false,
                "tableName": "currency",
                "subMenuUrl": "go/currencyList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Taxes",
                "subMenuDisplay": "Taxes",
                "subMenuOpen": false,
                "tableName": "tax",
                "subMenuUrl": "go/taxList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Documents",
                "subMenuDisplay": "Documents",
                "subMenuOpen": false,
                "tableName": "document",
                "subMenuUrl": "go/documentList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Agreements",
                "subMenuDisplay": "Agreements",
                "subMenuOpen": false,
                "tableName": "agreement",
                "subMenuUrl": "go/agreementList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Exchange",
                "subMenuDisplay": "Exchange",
                "subMenuOpen": false,
                "tableName": "exchange",
                "subMenuUrl": "go/exchangeList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Shipments",
                "subMenuDisplay": "Shipments",
                "subMenuOpen": false,
                "tableName": "shipment",
                "subMenuUrl": "go/shipmentList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "ShipmentCharges",
                "subMenuDisplay": "Shipment Charges",
                "subMenuOpen": false,
                "tableName": "shipmentCharges",
                "subMenuUrl": "go/shipmentChargesList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "ShippingConditions",
                "subMenuDisplay": "ShippingConditions",
                "subMenuOpen": false,
                "tableName": "shippingcondition",
                "subMenuUrl": "go/shippingConditionList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Incoterms",
                "subMenuDisplay": "Incoterms",
                "subMenuOpen": false,
                "tableName": "incoterms",
                "subMenuUrl": "go/incotermsList",
                "subSubMenus": []
            }
        ]
    },
    {
        "menuLabel": "Shipping",
        "menuIcon": <DirectionsBoat />,
        "menuOpen": false,
        "tableName": "",
        "menuUrl": "",
        "subMenus": [
            {
                "subMenuLabel": "Transports",
                "subMenuDisplay": "Transports",
                "subMenuOpen": false,
                "tableName": "Transports",
                "subMenuUrl": "go/transportList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Bookings",
                "subMenuDisplay": "Bookings",
                "subMenuOpen": false,
                "tableName": "Bookings",
                "subMenuUrl": "go/Bookings",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Booking Equipment",
                "subMenuDisplay": "Booking Equipment",
                "subMenuOpen": false,
                "tableName": "Booking Equipment",
                "subMenuUrl": "go/bookingEquipment",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "ApproveBooking",
                "subMenuDisplay": "ApproveBooking",
                "subMenuOpen": false,
                "tableName": "Approve Booking",
                "subMenuUrl": "go/approveBookingList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "BL's",
                "subMenuDisplay": "BL's",
                "subMenuOpen": false,
                "tableName": "BLs",
                "subMenuUrl": "go/BLs",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "ApproveBL",
                "subMenuDisplay": "ApproveBL",
                "subMenuOpen": false,
                "tableName": "Approve BL",
                "subMenuUrl": "go/approveBLList",
                "subSubMenus": []
            },
			{
                "subMenuLabel": "ShipmentCharges",
                "subMenuDisplay": "Shipment Charges",
                "subMenuOpen": false,
                "tableName": "shipmentCharges",
                "subMenuUrl": "go/shipmentChargesList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "eBL Documents",
                "subMenuDisplay": "eBL Documents",
                "subMenuOpen": false,
                "tableName": "eblDocuments",
                "subMenuUrl": "go/eblDocuments",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "eBL Party Names",
                "subMenuDisplay": "eBL Party Names",
                "subMenuOpen": false,
                "tableName": "eblPartyNames",
                "subMenuUrl": "go/eblPartyNames",
                "subSubMenus": []
            }
        ]
    },
    {
        "menuLabel": "EDI",
        "menuIcon": <IntegrationInstructions />,
        "menuOpen": false,
        "tableName": "",
        "menuUrl": "",
        "subMenus": [
            {
                "subMenuLabel": "EDI Integration",
                "subMenuDisplay": "EDI Integration",
                "subMenuOpen": false,
                "tableName": "EDI",
                "subMenuUrl": "go/edi",
                "subSubMenus": []
            }
        ]
    },
    {
        "menuLabel": "Eq. Control",
        "menuIcon": <AllInbox />,
        "menuOpen": false,
        "tableName": "",
        "menuUrl": "",
        "subMenus": [
            {
                "subMenuLabel": "Equipments",
                "subMenuDisplay": "Equipments",
                "subMenuOpen": false,
                "tableName": "Equipment and Movements",
                "subMenuUrl": "containerControl/equipmentAndMovementList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Last Movement",
                "subMenuDisplay": "Last Movement",
                "subMenuOpen": false,
                "tableName": "Last Movement",
                "subMenuUrl": "containerControl/lastMovementList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Range Movements",
                "subMenuDisplay": "Range Movements",
                "subMenuOpen": false,
                "tableName": "Last Movement",
                "subMenuUrl": "containerControl/rangeMovementList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Demurrage Control",
                "subMenuDisplay": "Demurrage Control",
                "subMenuOpen": false,
                "tableName": "Demurrage Control",
                "subMenuUrl": "containerControl/demurrageControlList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Demurrage Mov.",
                "subMenuDisplay": "Demurrage Mov.",
                "subMenuOpen": false,
                "tableName": "Demurrage Control",
                "subMenuUrl": "containerControl/demurrageMovementList",
                "subSubMenus": []
            }
        ]
    },
	{
        "menuLabel": "Master Tables",
        "menuIcon": <AccountBox />,
        "menuOpen": false,
        "tableName": "",
        "menuUrl": "",
		"subMenus": [
			{
			"subMenuLabel": "Shipping",
			"subMenuDisplay": "Shipping",
			"subMenuOpen": false,
			"tableName": "",
			"subMenuUrl": "",
			"subSubMenus": [
				{
					"subSubMenuLabel": "Trade",
					"subSubMenuDisplay": "Trade",
					"subSubMenuUrl": "go/tradeList",
				},
				{
					"subSubMenuLabel": "Vessel",
					"subSubMenuDisplay": "Vessel",
					"subSubMenuUrl": "master/vessel",
				},
				{
					"subSubMenuLabel": "Voyage",
					"subSubMenuDisplay": "Voyage",
					"subSubMenuUrl": "go/voyages",
				},
				{
					"subSubMenuLabel": "TransportClause",
					"subSubMenuDisplay": "Transport Clause",
					"subSubMenuUrl": "go/transportClauses",
				},
				{
					"subSubMenuLabel": "Location",
					"subSubMenuDisplay": "Location",
					"subSubMenuUrl": "go/locationList",
				},
				{
					"subSubMenuLabel": "Commodity",
					"subSubMenuDisplay": "Commodity",
					"subSubMenuUrl": "go/commodityList",
				},
				{
					"subSubMenuLabel": "DangerousGoods",
					"subSubMenuDisplay": "Dangerous Goods",
					"subSubMenuUrl": "go/dangerousGoodsList",
				}
				]
			},
			{
			"subMenuLabel": "Sales",
			"subMenuDisplay": "Sales",
			"subMenuOpen": false,
			"tableName": "",
			"subMenuUrl": "",
			"subSubMenus": [
				{
					"subSubMenuLabel": "LumpSum",
					"subSubMenuDisplay": "LumpSum",
					"subSubMenuUrl": "master/lumpSumList",
				},
				{
					"subSubMenuLabel": "ServiceType",
					"subSubMenuDisplay": "Service Type",
					"subSubMenuUrl": "go/serviceTypeList",
				},
				{
					"subSubMenuLabel": "ChargeRules",
					"subSubMenuDisplay": "Charge Rules",
					"subSubMenuUrl": "go/chargeRules",
				},
				{
					"subSubMenuLabel": "Currency",
					"subSubMenuDisplay": "Currency",
					"subSubMenuUrl": "go/currencyList",
				},
				{
					"subSubMenuLabel": "Exchange",
					"subSubMenuDisplay": "Exchange",
					"subSubMenuUrl": "go/exchangeList",
				},
                {
                    "subSubMenuLabel": "QuoteEquipmentDetails",
                    "subSubMenuDisplay": "Quote Eq. Details",
                    "subSubMenuUrl": "go/quoteEquipmentDetailList",
                }
				]
			},
			{
			"subMenuLabel": "Eq. Control",
			"subMenuDisplay": "Equipment",
			"subMenuOpen": false,
			"tableName": "",
			"subMenuUrl": "",
			"subSubMenus": [
				{
					"subSubMenuLabel": "Eq. Type",
					"subSubMenuDisplay": "Equipment Type",
					"subSubMenuUrl": "containerControl/equipmentTypeList",
				},
				{
					"subSubMenuLabel": "Eq. Status",
					"subSubMenuDisplay": "Equipment Status",
					"subSubMenuUrl": "containerControl/equipmentStatusList",
				},
				{
					"subSubMenuLabel": "Eq. Class",
					"subSubMenuDisplay": "Equipment Class",
					"subSubMenuUrl": "containerControl/equipmentClassList",
				},
				{
					"subSubMenuLabel": "Eq. Service",
					"subSubMenuDisplay": "Equipment Service",
					"subSubMenuUrl": "containerControl/equipmentServiceList",
				},
				{
					"subSubMenuLabel": "Eq. Leasing",
					"subSubMenuDisplay": "Equipment Leasing",
					"subSubMenuUrl": "containerControl/equipmentLeasingList",
				},
				{
					"subSubMenuLabel": "Eq. Condition",
					"subSubMenuDisplay": "Equipment Condition",
					"subSubMenuUrl": "containerControl/equipmentConditionList",
				},
				{
					"subSubMenuLabel": "Mov.Type Eq.Status",
					"subSubMenuDisplay": "Movement Type Equipment Status",
					"subSubMenuUrl": "containerControl/movTypeEqStatusList",
				},
				{
					"subSubMenuLabel": "Movement Type",
					"subSubMenuDisplay": "Movement Type",
					"subSubMenuUrl": "containerControl/movementTypeList",
				},
				{
					"subSubMenuLabel": "Sequence Mov.",
					"subSubMenuDisplay": "Sequence Movement",
					"subSubMenuUrl": "containerControl/sequenceMovementList",
				},
				{
					"subSubMenuLabel": "Demurrage Rule",
					"subSubMenuDisplay": "Demurrage Rule",
					"subSubMenuUrl": "containerControl/demurrageRuleList",
				},
				{
					"subSubMenuLabel": "Transport",
					"subSubMenuDisplay": "Transport",
					"subSubMenuUrl": "containerControl/transportList",
				},
				{
					"subSubMenuLabel": "Eq. Cost Rules",
					"subSubMenuDisplay": "Equipment Cost Rules",
					"subSubMenuUrl": "containerControl/equipmentCostRuleList",
				},
				{
					"subSubMenuLabel": "Eq. Cost Details",
					"subSubMenuDisplay": "Equipment Cost Details",
					"subSubMenuUrl": "containerControl/equipmentCostDetailList",
				},
				{
					"subSubMenuLabel": "Location Restriction",
					"subSubMenuDisplay": "Location Restriction",
					"subSubMenuUrl": "containerControl/locationRestrictionList",
				}
				]
			}
		]
	},
	{
        "menuLabel": "User Config",
        "menuIcon": <People />,
        "menuOpen": false,
        "tableName": "",
        "menuUrl": "",
        "subMenus": [
            {
                "subMenuLabel": "UserConfig",
                "subMenuDisplay": "UserConfig",
                "subMenuOpen": false,
                "tableName": "user config",
                "subMenuUrl": "go/UserConfig",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "RoleConfig",
                "subMenuDisplay": "RoleConfig",
                "subMenuOpen": false,
                "tableName": "role config",
                "subMenuUrl": "go/RoleConfig",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "UsersGroups",
                "subMenuDisplay": "UsersGroups",
                "subMenuOpen": false,
                "tableName": "usersGroups",
                "subMenuUrl": "go/usersGroupsList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Company",
                "subMenuDisplay": "Company",
                "subMenuOpen": false,
                "tableName": "company",
                "subMenuUrl": "master/company",
                "subSubMenus": []
            }
        ]
    },
	{
        "menuLabel": "GenericEntity",
        "menuDisplay": "Generic Entity",
        "menuIcon": <ViewModule />,
        "tableName": "GENERICENTITY",
        "menuUrl": "",  // Vazio porque vai ter submenus
        "subMenus": []  // Será preenchido dinamicamente
    }
]